import React, { FC } from 'react';
import Loading from 'react-loading';


export const LoadingPage: FC = () => {
    return (
        <div>
            <Loading
                type="spin"
                color="#fff"
                width="100px"
                height="100px"
                delay={0.2}
            />

            <style jsx>{`
                div {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 100vh;
                }
            `}</style>
        </div>
    );
};
